import Preloader from "components/Preloader/Preloader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components/macro";
import {
  fetchBannerOptions,
  selectBannerOptions,
  setBannerOptions,
  updateBanner,
} from "../bannersAdminSlice";
import BannerForm from "./BannerForm";
import { createBannerObj } from "./utils";

const EditBanner = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const fields = useSelector(selectBannerOptions);
  useEffect(() => {
    dispatch(fetchBannerOptions(id));
    return () => {
      dispatch(setBannerOptions(undefined));
    };
  }, [dispatch]);

  const onSubmit = (data: any) => {
    let obj = createBannerObj(data);

    const banner = { id: id, data: obj };
    dispatch(
      updateBanner(banner, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return fields ? (
    <BannerForm
      formTitle="Промяна на банер"
      onSubmit={onSubmit}
      fields={fields}
      progress={progress}
    />
  ) : (
    <LoaderWrapper>
      <Preloader />
    </LoaderWrapper>
  );
};
const LoaderWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: inline-flex;
  justify-content: center;
`;
export default EditBanner;
